<div mobile (mobileView)="isMobileView = $event" class="ceo-page-container margin-left-0 margin-right-0">
    <ng-template [ngIf]="!isMobileView">  <!--Global Filter by Year and Month-->
    <!--DESKTOP VIEW-->
        <div class="article-filter--container align-h">
                <div class="stretch"></div>
                <div class="filter-by-year-month-item">
                    <p class="filter-label">Filter by</p>
                    <!-- Select Year -->
                    <div class="form-group year-selection">
                        <mat-form-field appearance="standard">
                            <mat-select
                                disableOptionCentering
                                placeholder="Year"
                                [(ngModel)]="selectedYear"
                                name="year"
                                #year="ngModel" 
                                (selectionChange)="globalFiterByYearMonth($event)">
                                <mat-option class="font-16" *ngFor="let year of years" [value]="year.year">
                                {{ year?.year }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- Select Month -->
                    <div class="form-group month-selection">
                        <mat-form-field appearance="standard">
                            <mat-select
                                disableOptionCentering
                                placeholder="Month"
                                [(ngModel)]="selectedMonth"
                                name="month"
                                #month="ngModel" 
                                (selectionChange)="globalFiterByYearMonth($event)">
                                <mat-option class="font-16" *ngFor="let month of months" [value]="month.month">
                                    {{ month?.month }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
        </div>
        <!--Tabs-->
        <div class="ceo-tab-item-container">
            <mat-tab-group [selectedIndex]="selectedCategoryIndex" (selectedTabChange)="onCategoryChange($event)">
                <mat-tab *ngFor="let category of categories" [label]="category">
                    <!--Featured Tab List-->
                    <div class="ceo-featured-item-container">
                        <ng-template [ngIf]="categoryGroup?.featureArticleRows.length > 0">
                            <div class="custom-padding">
                                <h2 class="article--feature-header">Focus {{category}}</h2>
                                <!--FEATURE CATEGORY DATA-->
                                <div class="carousel slide feature-article--carousel" id="featuredArticleCarousel" data-ride="carousel" data-interval="3000">
                                <!-- Indicators -->
                                <ol class="carousel-indicators">
                                    <li *ngFor="let article of categoryGroup?.featureArticleRows; let i = index"
                                        data-target="#featuredArticleCarousel" attr.data-slide-to="{{ i }}" class="{{ i === 0 ? 'active' : '' }}">
                                    </li>
                                </ol>
                                    <!-- Wrapper for slides -->
                                    <div class="carousel-inner">
                                        <div class="carousel-item" *ngFor="let featureArticleRow of categoryGroup?.featureArticleRows; let i = index" [ngClass]="{ active: i === 0 }">
                                            <div class="row">
                                                <ng-template ngFor let-farticle [ngForOf]="featureArticleRow" let-j="index">
                                                    <div class="col-md-6" [ngClass]="{'padding-left-32': j%2!==0, 'padding-right-32': j%2===0}">
                                                        <app-article-card [article]="farticle"></app-article-card>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                    <!--SEARCH-->
                    <ng-template [ngIf]="categoryGroup.articleRows.length > 0">
                        <div class="article-search--container">
                                <div class="form-group">
                                    <mat-form-field class="search-form-input" appearance="standard">
                                        <input placeholder="Search" matInput [(ngModel)]="searchText" name="search" #search="ngModel">
                                        <img *ngIf="searchText?.length===0" matSuffix src="assets/icons/search_icon_white.png" />
                                        <button *ngIf="searchText?.length!==0" class="text-semi-light"  matSuffix  type="button"  mat-icon-button (click)="searchText=''" >
                                            <span class="material-icons">clear</span>
                                        </button>
                                    </mat-form-field>
                                </div>
                        </div>

                        <div class="no-article" *ngIf="(categoryGroup.articles | searchFilter:['title', 'shortDesc']:searchText)?.length === 0 ">No result Found!!!</div>
            
                        <!---CATEGORY DATA-->
                        <ng-template ngFor let-articleRow [ngForOf]="categoryGroup.articleRows" let-i="index">
                            <div *ngIf="i<viewLimit" class="row tab-item-container article-card--row">
                                <ng-template ngFor let-article [ngForOf]="articleRow | searchFilter:['title', 'shortDesc']:searchText" let-j="index">
                                    <div class="col-md-6" [ngClass]="{'padding-left-32': j%2!==0, 'padding-right-32': j%2===0}">
                                        <app-article-card [article]="article"></app-article-card>
                                    </div>
                                </ng-template>
                            </div>
                        </ng-template>
                    </ng-template>
                    <!---VIEW MORE-->
                    <div class="ceo-article-button-item">
                        <ng-template [ngIf]="viewLimit!==categoryGroup.articleRows.length && (categoryGroup.articles | searchFilter:['title', 'shortDesc']:searchText)?.length > 0 ">
                            <hr>
                            <button type="button" class="btn btn-primary btn-lg margin-top-30" (click)="onViewMore()">
                                    View All
                            </button>
                        </ng-template>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div> 
        <ng-template [ngIf]="!categoryGroup?.featureArticleRows?.length && !categoryGroup?.articleRows?.length">
            <div class="no-article">
                None at this time
            </div>
        </ng-template>
    </ng-template>
    <ng-template [ngIf]="isMobileView">
        <app-ceo-desk-mobile [years]="years" [months]="months" [categories]="categories"></app-ceo-desk-mobile>
    </ng-template>
  
</div>
